import { render, staticRenderFns } from "./HubAddressUpdate.vue?vue&type=template&id=b12ac6de"
import script from "./HubAddressUpdate.vue?vue&type=script&lang=js"
export * from "./HubAddressUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports